import { io } from 'socket.io-client';
import { API_BASE_URL } from '@/config/api';

let socket = null;
const listeners = new Set();

export function connectPedidosSocket(usuarioNegocio) {
    if (!usuarioNegocio || usuarioNegocio === 'admin') return null;
    if (socket && socket.connected) return socket;

    if (socket) {
        socket.disconnect();
        socket = null;
    }

    socket = io(API_BASE_URL.replace(/\/$/, ''), {
        transports: ['websocket', 'polling'],
        query: { usuario: usuarioNegocio },
    });

    socket.on('pedido:nuevo', (pedido) => {
        listeners.forEach((fn) => {
            try {
                fn(pedido);
            } catch (e) {
                console.warn('[socket] listener', e);
            }
        });
    });

    return socket;
}

export function onNuevoPedido(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
}

export function disconnectPedidosSocket() {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
    listeners.clear();
}

export function playPedidoSound() {
    try {
        const ctx = new (window.AudioContext || window.webkitAudioContext)();
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.type = 'sine';
        osc.frequency.value = 880;
        gain.gain.value = 0.08;
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.start();
        setTimeout(() => {
            osc.stop();
            ctx.close();
        }, 180);
    } catch (_) {
        /* ignore */
    }
}
